package com.bikompanion.data

/**
 * How this platform reaches api.citybik.es.
 *
 * The two fields always co-vary, so they're decided together: a client that can send the
 * `x-api-key` header talks to the API directly, and one that can't goes through a proxy that
 * attaches the key on its behalf.
 */
internal data class CityBikesEndpoint(
    val baseUrl: String,
    /**
     * Whether the HTTP client attaches `x-api-key` itself. False when something upstream
     * already does it, in which case sending it here would be redundant at best.
     */
    val sendsApiKeyHeader: Boolean,
)
